<template>
    <div id="pageDashboard">
        <v-dialog max-width="450px" v-model="dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text class="pt-0">
                    <v-container grid-list-md>
                        <v-form data-vv-scope="formExtraTask" lazy-validation>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :error-messages="errors.collect('formExtraTask.name')"
                                        data-vv-name="name"
                                        label="Name"
                                        v-model="editedItem.name"
                                        v-validate="{required: true, max: 100}"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-switch
                                        :label="editedItem.status ? 'Active': 'Inactive'"
                                        v-model="editedItem.status"
                                        color="primary"
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea label="Comment" rows="1" v-model="editedItem.comment"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogConfirm = true">Cancel</v-btn>
                    <v-btn @click="save" color="primary">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="450px" persistent v-model="dialogConfirm">
            <v-card>
                <v-card-title>
                    <span class="headline">Alert</span>
                </v-card-title>
                <v-card-text>{{ title2 }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
                    <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-toolbar class="top-content" flat>
            <v-toolbar-title class="title-box pt-3 pb-3">
                <span class="title">Extra Task</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="moduleData"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsPerPageItems"
            :total-items="totalItems"
            item-key="items.key"
        >
            <template v-slot:headers="props">
                <th
                    :class="['column', !(typeof header.sortable === 'boolean' && !header.sortable) ? 'sortable' : '', header.align ? header.align : 'text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    :key="header.text"
                    @click="changeSort(header)"
                    v-for="header in props.headers"
                >
                    {{ header.text }}
                    <v-icon small v-if="!(typeof header.sortable === 'boolean' && !header.sortable)">arrow_upward</v-icon>
                </th>
            </template>
            <template slot="items" slot-scope="props">
                <tr>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-center">{{ props.item.status ? "Active" : 'Inactive' }}</td>
                    <td class="text-xs-center">
                        <v-icon @click="editItem(props.item)" class="mr-2" small>edit</v-icon>
                    </td>
                </tr>
            </template>
            <template v-slot:actions-prepend>
                <div class="actions-list">
                    <v-btn @click="dialog =true" color="primary">Add</v-btn>
                </div>
            </template>
        </v-data-table>
    </div>
</template>
<script>

import ExtraTaskService from "../services/extra.task.service";
import configs from "../config/config";

export default {
    inject: ["$validator"],
    metaInfo() {
        return {
            title: "Dashboard cibes"
        };
    },
    data: () => ({
        dialogConfirm: false,
        pagination: {
            sortBy: "",
            rowsPerPage: 10,
            page: 1
        },
        totalItems: 0,
        dialog: false,
        editedIndex: -1,
        extraTaskService: new ExtraTaskService(),
        editedItem: {
            name: "",
            apply_job: [2, 1, 3],
            status: true,
            comment: ""
        },
        btnLoading: false,
        id: "",
        apppyJobs: [
            {
                text: "Maintain",
                value: 2
            },
            {
                text: "Site check",
                value: 1
            },
            {
                text: "Repair",
                value: 3
            },
            {
                text: "Acceptance",
                value: 5
            }
        ],
        headers: [
            {
                text: "Name",
                value: "name"
            },
            { text: "Status", align: "text-xs-center", value: "status", sortable: false },
            { text: "Action", align: "text-xs-center", sortable: false }
        ],
        moduleData: [],
        rowsPerPageItems: [10, 20, 50],
        dictionary: {
            custom: {
            }
        },
        click1: false
    }),
    created() {
    },
    watch: {
        pagination: {
            handler() {
              !this.btnLoading && this.getData();
            },
            deep: true
        },
        userInfo() {
            if (this.userInfo && this.userInfo.user_type !== configs.isAdmin && this.userInfo.user_type !== configs.isSuperAdmin) {
                this.$router.push("/dashboard");
            }
        }
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? "Create new Extra Task"
                : "Edit new Extra Task";
        },
        title2() {
            return this.editedIndex === -1
                ? "Are you sure to cancel the new creation?"
                : "Are you sure to cancel the changes?";
        },
        userInfo() {
            return this.$store.getters["auth/currentUser"];
        }
    },
    mounted() {
        this.$validator.localize("en", this.dictionary);
        if (this.userInfo && (this.userInfo.user_type !== configs.isAdmin) && this.userInfo.user_type !== configs.isSuperAdmin) {
            this.$router.push("/dashboard");
        }
    },
    methods: {
        changeSort(data) {
            if (typeof data.sortable === "boolean" && !data.sortable) return;
            const column = data.value;
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
            // this.pagination.page = 1;
        },
        close() {
            this.dialog = false;
            this.dialogConfirm = false;

            setTimeout(() => {
                this.$validator.reset();
                this.editedItem = {
                    name: "",
                    apply_job: [1, 2, 3],
                    status: true,
                    comment: ""
                };
                this.editedIndex = -1;
                this.click1 = false;
            }, 500);
        },
        getData() {
            this.btnLoading = true;
            let params = {
                page: this.pagination.page,
                hidden: true,
                limit: this.pagination.rowsPerPage
            };
            //const _this = this;
            if (this.pagination.sortBy) {
                params.sort =
                    (this.pagination.descending ? "-" : "") +
                    this.pagination.sortBy;
            }
            this.extraTaskService.getList(params).then(res => {
                this.moduleData = res.docs;
                this.btnLoading = false;
                this.totalItems = res.total;
                this.pagination.page = res.page;
                stop();
            });
        },
        editItem(item) {
            this.editedIndex = this.moduleData.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.id = this.moduleData[this.editedIndex].id;
            this.dialog = true;
        },
        save() {
            const _this = this;
            if (this.click1) return;
            this.click1 = true;
            this.$validator.validate("formExtraTask.*").then(result => {
                if (result) {
                    if (this.editedIndex === -1) {
                        this.extraTaskService.add(this.editedItem).then(res => {
                            if (res.data) {
                                this.getData();
                            }
                            this.close();
                        });
                    } else {
                        this.extraTaskService
                            .edit(this.editedItem, this.id)
                            .then(res => {
                                if (res.data) {
                                    this.getData();
                                }
                                this.close();
                            });
                    }
                } else {
                    _this.click1 = false;
                }
            });
        }
    }
};
</script>
<style>
#pageDashboard .v-datatable__actions {
    position: relative;
}

@media screen and (min-width: 1080px){
  .actions-list {
    left: calc(50% - 55px);
  }
}
.actions-list {
    position: absolute;
    top: 5px;
}
.v-card__title {
    font-size: 18px;
    font-weight: bold;
    background-color: #f5f5f5;
}
.v-card__actions {
    padding: 15px 10px;
}
.top-content {
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.87);
}
table.v-table tbody td {
    word-break: break-word;
}
table.v-table tbody td:nth-child(1) {
    max-width: 300px;
}
.v-list__tile__action .v-input--selection-controls .v-input__slot {
    margin: 0;
}
</style>
